import {axios as http} from "@/plugins/http"

export default class Api {
    static shops() {
        return http.post("/api/v1/post/shops").then((resp) => {
            return resp.data["items"]
        })
    }
}
